<ng-container *cmLet="(currencyIcon$ | async) as currencyIcon">
    <ng-container *ngFor="let field of feesFormFields">
        <div
            [ngClass]="{ 'is-discount-field': isDiscountField, 'is-admin-discount': isDiscountField && isAdminPreview }"
            *cmLet="field.typeId === FIELD_TYPES.DISCOUNTED_PRICE as isDiscountField"
            class="field-container"
        >
            <span class="field-name">{{ field.name }}</span>
            <div class="header field-item">
                <span class="column-description">Description</span>
                <ng-container *ngIf="isAdminPreview && isDiscountField; else commonHeaderPrice">
                    <span class="column-price">Full Price</span> <span class="column-price">Discount Rate</span>
                    <span class="column-price">Discount Price</span>
                </ng-container>
                <ng-template #commonHeaderPrice><span class="column-price">Price</span></ng-template>
                <span class="column-quantity">Quantity</span> <span class="column-subtotal">Subtotal</span>
            </div>
            <div *ngFor="let option of field.options" class="field-item option-item">
                <ng-container *cmLet="field.typeId === FIELD_TYPES.PRICE_OPTIONS as isOptionsField">
                    <cm-radio
                        class="radio-option"
                        [disabled]="previewMode"
                        *ngIf="isOptionsField"
                        [checked]="option.selected"
                        (click)="onRadioClick(option, field)"
                        [name]="field.fieldId"
                    ></cm-radio>
                    <div class="column-description" [ngClass]="{ 'is-options-field': isOptionsField }">
                        {{ option.name }}
                    </div>
                    <ng-container *ngIf="isAdminPreview && isDiscountField; else commonItemPrice">
                        <span class="column-price">{{ currencyIcon }}{{ option.price | cmCurrency }}</span>
                        <span class="column-price">{{ option.discountRate | percent }}</span>
                        <span class="column-price"
                            >{{ currencyIcon }}{{ getDiscountedPrice(option) | cmCurrency }}</span
                        >
                    </ng-container>
                    <ng-template #commonItemPrice>
                        <div class="column-discount" *ngIf="isDiscountField">
                            <span class="discount-label">{{ option.discountRate | percent }}</span>
                        </div>
                        <div class="column-price">
                            <span class="mobile-label">Price</span>
                            <span *ngIf="!isDiscountField">{{ currencyIcon }}{{ option.price | cmCurrency }}</span>
                            <div *ngIf="isDiscountField" class="discount-price-container">
                                <span class="initial-price">{{ currencyIcon }}{{ option.price | cmCurrency }}</span>
                                <span>{{ currencyIcon }}{{ getDiscountedPrice(option) | cmCurrency }}</span>
                            </div>
                        </div>
                    </ng-template>
                    <div class="column-quantity">
                        <span class="mobile-label">Quantity</span>
                        <cm-number-input
                            [disabled]="previewMode || (!previewMode && isOptionsField && !option.selected)"
                            class="number-input"
                            [maskConfig]="numberMaskConfigForQuantity"
                            [ngModel]="option.quantity"
                            (ngModelChange)="onQuantityChange($event, option, field.typeId)"
                        >
                        </cm-number-input>
                    </div>
                    <div class="column-subtotal">
                        <span class="mobile-label">Subtotal</span>
                        <span>{{ currencyIcon }}{{ option.subtotal | cmCurrency }}</span>
                    </div>
                </ng-container>
            </div>
            <div class="total-container total-container-field">
                <span>Total:</span>
                <span>{{ currencyIcon }}{{ calculateFieldTotal(field.options, field.typeId) | cmCurrency }}</span>
            </div>
        </div>
    </ng-container>
    <div class="total-container total-container-grand">
        <span>Grand total: </span> <span>{{ currencyIcon }}{{ calculateGrandTotal() | cmCurrency }}</span>
    </div>
</ng-container>
